import { Text } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

import './index.styles.css'
type ClearValueProps = {
  onClear: () => void
  text?: string
}

const ClearValue = ({ onClear, text = i18n.t('common.clear_selection') }: ClearValueProps) => {
  return (
    <button className={'_Dropdown_clear'} onClick={onClear}>
      <Text.Normal size="300" weight="medium" color="radicalRed1200">
        {text}
      </Text.Normal>
    </button>
  )
}

export default ClearValue
